import api from './api'

export const notificationService = {
  // Basic notifications
  getAll: () =>
    api.get('/notifications'),

  getUnread: () =>
    api.get('/notifications/unread'),

  markAsRead: (id: number) =>
    api.patch(`/notifications/${id}/read`),

  markAllAsRead: () =>
    api.patch('/notifications/read-all'),

  delete: (id: number) =>
    api.delete(`/notifications/${id}`),

  // Templates
  getTemplates: () =>
    api.get('/notifications/templates'),

  createTemplate: (data: any) =>
    api.post('/notifications/templates', data),

  updateTemplate: (id: number, data: any) =>
    api.put(`/notifications/templates/${id}`, data),

  deleteTemplate: (id: number) =>
    api.delete(`/notifications/templates/${id}`),

  // Notification History / Logs
  getHistory: (params?: { 
    customer?: number
    status?: string
    channel?: string
    page?: number
    limit?: number
    startDate?: string
    endDate?: string
  }) => api.get('/notifications/history', { params }),

  // SMS Credits
  getSMSCredits: () =>
    api.get('/notifications/sms-credits'),

  refillSMSCredits: (data: { amount: number; provider_name?: string }) =>
    api.post('/notifications/sms-credits/refill', data),

  // Bulk Send
  getRecipients: () =>
    api.get('/notifications/recipients'),

  sendBulk: (data: {
    customer_ids?: number[]
    group_ids?: number[]
    channel: 'email' | 'sms' | 'both'
    subject?: string
    body: string
    attachments?: Array<{
      filename: string
      content: string
      contentType: string
    }>
    use_template?: boolean
    template_id?: number
    variables?: Record<string, string>
  }) => api.post('/notifications/bulk-send', data),

  // Single send
  send: (data: {
    customer_id: number
    template_id?: number
    channel: 'email' | 'sms' | 'both'
    custom_subject?: string
    custom_body?: string
    reference_type?: string
    reference_id?: number
    variables?: Record<string, string>
  }) => api.post('/notifications/send', data),

  // Reminders
  getReminders: () =>
    api.get('/notifications/reminders'),

  scheduleReminder: (data: any) =>
    api.post('/notifications/reminders', data),

  cancelReminder: (id: number) =>
    api.delete(`/notifications/reminders/${id}`),

  getCustomersWithBalance: () =>
    api.get('/notifications/customers-with-balance'),

  sendBulkReminders: (data: any) =>
    api.post('/notifications/bulk-reminders', data),

  // Receipt generation
  generateReceiptPDF: (saleId: number) =>
    api.post('/notifications/generate-receipt', { sale_id: saleId }, { responseType: 'blob' }),

  sendReceiptEmail: (data: { sale_id: number; custom_message?: string }) =>
    api.post('/notifications/send-receipt', data),
}
